import { Alert, AlertTitle } from '@mui/material';

import { InfoBox } from '@/components/InfoBox';
import Typography from '@/components/Typography';

const alertStyles = {
  backgroundColor: 'inherit',
  color: 'inherit',
  py: 1,

  '& .MuiAlert-icon': {
    color: 'primary.main',
    paddingTop: 0.5
  }
} as const;

const NoDataDateAlert = () => {
  return (
    <InfoBox
      sx={{
        mb: 2
      }}
    >
      <Alert
        severity='info'
        sx={alertStyles}
      >
        <AlertTitle sx={{ fontSize: '12px', mb: '8px' }}>
          No data available for this selection
        </AlertTitle>
        <Typography sx={{ fontSize: '12px' }}>Try adjusting your export settings.</Typography>
      </Alert>
    </InfoBox>
  );
};

export default NoDataDateAlert;
